<div mat-dialog-title *ngIf="ModelTab == 0">
  Do you have Parent Company?
</div>
<div mat-dialog-title *ngIf="ModelTab == 1">
  Define a Nickname for your Business
</div>
<mat-dialog-content>
  <form [formGroup]="parentCompnyGroup" *ngIf="ModelTab == 0">
    <div class="row">
      <div class="col-12">
        <mat-form-field class="col-12">
          <input type="text" placeholder="Enter your parent company name" formControlName="prntCmpny"
            aria-label="Number" matInput [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)='getNickname($event)'>
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option.nickname}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="parentCompnyGroup.get('prntCmpny').errors">Enter your parent company name</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
  <form [formGroup]="nickNameGroup" *ngIf="ModelTab == 1">
    <div class="row">
      <div class="col-12">
        <mat-form-field class="col-12">
          <input matInput placeholder="Enter your Business Profile Nickname" formControlName="nickName">
          <mat-error *ngIf="nickNameGroup.get('nickName').errors">Enter your Business Profile Nickname</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="d-flex justify-content-end col-12">
    <button *ngIf="ModelTab == 0" mat-stroked-button color="primaryStrCus" class="mx-1"
      (click)="ModelTab =1;parentCompnyGroup.reset()">SKIP</button>
    <button *ngIf="ModelTab == 0" mat-raised-button color="primaryCus" [disabled]="!parentCompnyGroup.valid"
      (click)="ModelTab =1;">SAVE</button>
    <button *ngIf="ModelTab == 1" [disabled]="!nickNameGroup.valid"
      [mat-dialog-close]="{'parentCompany':parentCompanyID,'nickName':nickNameGroup.get('nickName').value}"
      mat-raised-button color="primaryCus">SAVE</button>
  </div>
</mat-dialog-actions>